<template>
    <div class="item-product rounded-lg overflow-hidden shadow mb-3 relative bg-white" v-if="$parent.templateView == '' || $parent.templateView == 'list' || $parent.templateView == 'list_np'">
        <div class="relative" style="padding-bottom: 66.6%" v-if="item.image && $parent.templateView !== 'list_np'">
            <img class="absolute h-full object-cover w-full" v-lazy="getLasyImage($root.getImage(item.image))" alt="" >
        </div>
        <div class="px-3 py-4">
            <div class="flex items-start justify-between mb-2">
                <div class="name_product" :class="[isPopup ? 'text-big' : '']" v-text="item.title[$root.currentLanguage]"></div>			
                <span class="ml-1 -mb-1 inline-block relative" v-if="item.product_icons.length > 0">
                    <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
                </span>
            </div>
            
            <template v-if="getFullDescr.length > 0">
                <div class="text-gray-600 text-xs" v-html="getFullDescr"></div>
            </template>
            <div class="flex items-center justify-between mt-5">
                <div class="price_product" v-html="$root.showPrice(item.price, item.is_price_from)"></div>
                <div class="">
                    <div v-if="section.files && section.files.length > 0">
                        <div class="flex justify-end items-center mb-2" v-for="(file, index) in section.files"  :key="index">											
                            <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" target="_blank">
                                {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                            </a>
                        </div>
                    </div>
                    <button :class="[(!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'product_add_cart text-white']" class="flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-32 text-sm text-center uppercase" style="margin-left: auto;" @click="$emit('click')"  v-if="$parent.displayOrderButton" v-text="buttonOrderText"></button>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="$parent.templateView == 'list_sm' || $parent.templateView == 'list_sm_np'">
        <div class="item-product bg-white rounded-2xl mb-3 p-3 rounded-xl shadow w-full flex gap-3">       
            <div class="bg-cover bg-top rounded-xl h-24 w-32 md:h-32 md:w-40 flex-shrink-0"  v-if="$parent.templateView !== 'list_sm_np'">
                <img v-if="item.image" class=" h-full object-cover w-full rounded-xl" v-lazy="getLasyImage($root.getImage(item.image))" alt="">
                <img v-else class=" h-full object-cover w-full rounded-xl"  :src="require(`@/assets/image/loading_product.svg`)" >
            </div>                
            <div class="w-full flex flex-col justify-between">
                <div class="h-full flex flex-col justify-between">
                    <div>
                        <div :class="['leading-tight', $parent.displayOrderButton ? 'line-clamp-2' : '', 'truncate-text']" v-text="item.title[$root.currentLanguage]"></div>
                        <span class="inline-block relative mt-2" v-if="item.product_icons.length > 0">
                            <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
                        </span>
                        <template v-if="getFullDescr.length > 0">
                            <div class="text-gray-600 mt-2 text-xs" v-html="getFullDescr"></div>
                        </template>
                    </div>
                    <div v-if="section.files && section.files.length > 0">
                        <div class="flex justify-end items-center mb-2" v-for="(file, index) in section.files"  :key="index">											
                            <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" target="_blank">
                                {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                            </a>
                        </div>
                    </div>                        
                </div>
                <div class="flex justify-end" >
                    <button  :class="[(!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'bg-hotel text-white']" class="h-8 px-4 text-center rounded-full leading-none" 
                        v-if="$parent.displayOrderButton" 
                        v-html="item.price > 0 ? $root.showPrice(item.price, item.is_price_from) : buttonOrderText"></button>
                    <div :class="[(!item.in_schedule || !section.in_schedule) ? 'text-gray-700' : 'text-black']" class="leading-none whitespace-no-wrap mx-2" 
                        v-else 
                        v-html="$root.showPrice(item.price, item.is_price_from)"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="item-product bg-white rounded-2xl shadow h-full flex flex-col justify-between">
            <div>
                <div class="relative" style="padding-bottom: 66.6%"  v-if="$parent.templateView !== 'grid_np'">
                    <img v-if="item.image" class="absolute h-full object-cover w-full rounded-t-2xl" v-lazy="getLasyImage($root.getImage(item.image))" alt="">
                    <img v-else class="absolute h-full object-cover w-full rounded-t-2xl"  :src="require(`@/assets/image/loading_product.svg`)" >
                </div>
                <div class="p-3 ">
                    <div>
                        <div :class="['leading-tight', $parent.displayOrderButton ? 'line-clamp-2' : '']" v-text="item.title[$root.currentLanguage]"></div>
                        <span class="inline-block relative" v-if="item.product_icons.length > 0">
                            <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
                        </span>
                        <template v-if="getFullDescr.length > 0">
                            <div class="text-gray-600 mt-2 text-xs" v-html="getFullDescr"></div>
                        </template>
                        <div v-if="section.files && section.files.length > 0">
                            <div class="flex justify-end items-center mb-2" v-for="(file, index) in section.files"  :key="index">											
                                <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" target="_blank">
                                    {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3 ">
                <button v-if="$parent.displayOrderButton" :class="[(!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'bg-hotel text-white']" class="h-8 px-2 w-full text-center rounded-full" v-html="item.price > 0 ? $root.showPrice(item.price, item.is_price_from) : buttonOrderText">1 350 ₽</button>
                <div :class="[(!item.in_schedule || !section.in_schedule) ? 'text-gray-700' : 'text-black']" class="leading-none whitespace-no-wrap" v-else v-html="$root.showPrice(item.price, item.is_price_from)"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'item', 
        'isPopup', 
        'section', 
        'getShortDescr', 
        'getFullDescr',
        'buttonOrderText',
        'view'
    ],
}
</script>